import axios from 'axios';

import { ViewAmostraAtual } from '@models/views/view-amostra-atual.model';
import { CriaAmostrasCatalisadoresDto } from '@/../../back/src/amostras-catalisadores/dto/cria-amostras-catalisadores.dto';
import { ListaAcompanhamentoAmostraCatalisadorQueryDto } from '@/../../back/src/amostras-catalisadores/dto/lista-acompanhamento-amostra-catalisador-query.dto';
import { CriaPecasAmostrasCatalisadoresDto } from '@/../../back/src/amostras-catalisadores/dto/cria-pecas-amostras-catalisadores.dto';
import { AmostraCatalisador } from '@models/amostra-catalisador.model';
import { ColetaLaboratorioCatalisadoresDto } from '@/../../back/src/amostras-catalisadores/dto/coleta-laboratorio-catalisadores.dto';
import { AmostraLog } from '@models/amostra-log.model';

const listaProducao = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>(
    '/amostras_catalisadores/producao',
  );
  return res.data;
};
const listaDisplay = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>(
    '/amostras_catalisadores/display',
  );
  return res.data;
};

const listaAcompanhamento = async (
  queryDto: ListaAcompanhamentoAmostraCatalisadorQueryDto,
): Promise<{
  count: number;
  rows: ViewAmostraAtual[];
}> => {
  const res = await axios.get<{ count: number; rows: ViewAmostraAtual[] }>(
    '/amostras_catalisadores/acompanhamento',
    {
      params: queryDto,
    },
  );
  return res.data;
};

const cria = async (
  formData: CriaAmostrasCatalisadoresDto,
): Promise<AmostraCatalisador[]> => {
  const res = await axios.post<AmostraCatalisador[]>(
    '/amostras_catalisadores',
    formData,
  );
  return res.data;
};

const busca = async (
  amostraCatalisadorId: number,
): Promise<AmostraCatalisador> => {
  const response = await axios.get<AmostraCatalisador>(
    `/amostras_catalisadores/${amostraCatalisadorId}`,
  );
  return response.data;
};
const criaPecas = async (
  formData: CriaPecasAmostrasCatalisadoresDto,
): Promise<AmostraCatalisador[]> => {
  const res = await axios.post<AmostraCatalisador[]>(
    '/amostras_catalisadores/pecas',
    formData,
  );
  return res.data;
};

const coletaLaboratorio = async (
  amostrasCatalisadoresIds: ColetaLaboratorioCatalisadoresDto,
): Promise<AmostraLog[]> => {
  const response = await axios.post<AmostraLog[]>(
    '/amostras_catalisadores/coletar_laboratorio',
    amostrasCatalisadoresIds,
  );
  return response.data;
};

const remove = async (
  amostraCatalisadorId: number,
): Promise<AmostraCatalisador> => {
  const response = await axios.delete<AmostraCatalisador>(
    `/amostras_catalisadores/${amostraCatalisadorId}`,
  );
  return response.data;
};

export default {
  listaProducao,
  listaDisplay,
  listaAcompanhamento,
  cria,
  busca,
  criaPecas,
  coletaLaboratorio,
  remove,
};
